
import Toastr from "../../../components/Toastr";

const parent = "SETTING_";

const initialState = {
  list: [],
  meta: {},
  loading: false,
  error: null,
};

export default function promotionsReducer(state = initialState, action) {
  const response =
    action.payload && (action.payload.data || action.payload.response);

  switch (action.type) {
    case `${parent}PROMOTIONS_LOAD_PENDING`:
    case `${parent}PROMOTION_CREATE_PENDING`:
    case `${parent}PROMOTION_UPDATE_PENDING`:
      return { ...state, loading: true, error: null };

    // Detail GET /settings/promotions/:id — do not toggle listing `loading`
    case `${parent}PROMOTION_LOAD_PENDING`:
      return { ...state, error: null };

    case `${parent}MASTER_PROMOTIONS_LOAD_PENDING`:
      return { ...state, masterLoading: true, error: null };

    case `${parent}PROMOTIONS_LOAD_REJECTED`:
    case `${parent}PROMOTION_CREATE_REJECTED`:
    case `${parent}PROMOTION_UPDATE_REJECTED`:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case `${parent}PROMOTION_LOAD_REJECTED`:
      return {
        ...state,
        error: action.payload,
      };

    case `${parent}MASTER_PROMOTIONS_LOAD_REJECTED`:
      return {
        ...state,
        masterLoading: false,
        error: action.payload,
      };

    case `${parent}PROMOTIONS_LOAD_FULFILLED`:
      return {
        ...state,
        loading: false,
        list: response?.promotions || response?.data || [],
        meta: response?.meta || {},
      };

    case `${parent}MASTER_PROMOTIONS_LOAD_FULFILLED`:
      return {
        ...state,
        masterLoading: false,
        masterList: response?.promotions || response?.data || [],
        masterMeta: response?.meta || {},
      };

    // Detail load: keep listing as-is (modal uses drawerLoading)
    case `${parent}PROMOTION_LOAD_FULFILLED`:
      return { ...state };

    case `${parent}PROMOTION_CREATE_FULFILLED`:
    case `${parent}PROMOTION_UPDATE_FULFILLED`: {
      if (response?.meta?.message) {
        Toastr.handleShow(true, response.meta.message, 201);
      }

      const promotion =
        response?.promotion || response?.data || response;

      if (!promotion || promotion.id == null) {
        return { ...state, loading: false };
      }

      const currentList = Array.isArray(state.list) ? state.list : [];
      const exists = currentList.some((item) => item.id === promotion.id);

      const list = exists
        ? currentList.map((item) =>
            item.id === promotion.id ? promotion : item
          )
        : action.type === `${parent}PROMOTION_CREATE_FULFILLED`
        ? [promotion, ...currentList]
        : [...currentList, promotion];

      return {
        ...state,
        loading: false,
        list,
      };
    }

    default:
      return state;
  }
}
